import { useNavigate } from "react-router-dom";
import { galleryData } from "../data/galleryData";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const GalleryPage = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-neutral-950 min-h-screen">
      <Navigation />

      <section className="bg-neutral-900 py-24 lg:py-32">
        <div className="max-w-[1800px] mx-auto px-6 lg:px-12">

          {/* Header */}
          <div className="text-center mb-20">
            <span className="text-[#d4af37] text-xs tracking-[0.4em] block mb-4">
              ALL COLLECTIONS
            </span>
            <h1 className="text-4xl lg:text-5xl text-white font-light">
              Gallery
            </h1>
          </div>

          {/* Categories Grid (SAME AS HOME) */}
          <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
            {galleryData.map((cat, i) => (
              <div
                key={cat.slug}
                onClick={() => navigate(`/gallery/${cat.slug}`)}
                className="group cursor-hover relative aspect-[3/4] overflow-hidden"
                style={{ animationDelay: `${i * 0.2}s` }}
              >
                <img
                  src={cat.cover}
                  alt={cat.title}
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500" />

                {/* Content */}
                <div className="absolute inset-0 flex flex-col justify-end p-8">
                  {cat.subtitle && (
                    <span className="text-[#d4af37] text-xs tracking-[0.3em] mb-3">
                      {cat.subtitle}
                    </span>
                  )}

                  <h3 className="text-2xl lg:text-3xl text-white font-serif font-light group-hover:translate-y-0 translate-y-2 transition-transform duration-500">
                    {cat.title}
                  </h3>

                  <div className="h-px bg-gradient-to-r from-[#d4af37] to-transparent w-0 group-hover:w-full transition-all duration-700 mt-6" />
                </div>

                {/* Corner Frame */}
                <div className="absolute top-4 left-4 right-4 bottom-4 border border-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GalleryPage;
